// extracted by mini-css-extract-plugin
export default {"about_section":"about_about_section__2r3wN","about_data_container":"about_about_data_container__vvfl1","about_data_box":"about_about_data_box__lMBIg"};